import React from 'react';
import { Link } from 'dva/router';
import { Divider } from 'antd';
import LinesEllipsis from 'react-lines-ellipsis';
import { Row, Col } from 'antd';
import styles from './rec_b.css';
class RecB extends React.Component {
    render() {
        console.log("RecB", this.props);
        const content = this.props.data.map((item) => {
            const { pic, novel_id, name, cata, author, brief, } = item;
            return <Link to={`/book/detail/${novel_id}`} key={novel_id}>
                <div className={styles.wrap_content_item}>
                    <div style={{ height: '270px', width: '212px', overflow:"hidden", position: 'relative' }}>
                        <img alt='' src={pic} className={styles.hover_img} />
                        <img alt='' src="https://img.cgwrite.cn/qa/up/2508/276281.png" style={{ position: 'absolute', left: '0', top: '0', width: '100px' }} />
                    </div>
                    <div style={{ fontSize: '16px', lineHeight: '22px', color: '#333333', margin: '10px 0 10px 0', textAlign: 'center' }}>
                        <LinesEllipsis maxLine={1} text={name} title={name} />
                    </div>
                    <div style={{ fontSize: '14px', lineHeight: '20px', color: '#999999', margin: '0 0 10px 0', textAlign: 'center' }}>
                        {cata}{author && <span><Divider type="vertical" />{author}</span>}
                    </div>
                </div>
            </Link>;
        })
        return (
            <div className={styles.wrap}>
                <h3>&gt;&gt;新书爆款！</h3>
                <Row type="flex" justify="flex-start">
                    {content}
                </Row>
            </div>
        )
    }
}

export default RecB;


// WEBPACK FOOTER //
// ./src/component/rec/rec_b.js